var render = function render(){var _vm=this,_c=_vm._self._c;return _c('broadcast-card',{attrs:{"eyebrow":"Στατιστικά αγώνα","title":"Εξέλιξη σκορ"}},[_c('score-evolution-chart',{attrs:{"logs":_vm.logs,"team1":_vm.match.team1,"team2":_vm.match.team2,"broadcast":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }